export const eTransportTypes = {
  NEEDTRANSPORT: 0,
  COURIERSERVICE: 1,
  CLIENTTRANSPORT: 2,
};